import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useGlobalState } from '../../contexts/GlobalStateContext';
import { CartContext } from '../Context/cart/CartContext';
import { confirmAlert } from '../Confirm';

export default function CompanySelect() {
    const { globalState, globalDispatch } = useGlobalState();
    const { availableCompanies, activeUserCompany } = globalState;
    const { cartItems, clearCart } = useContext(CartContext);
    const { t } = useTranslation();
    const location = useLocation();

    const disabledUrls = [
        '/cpq',
        '/shop',
        '/checkout',
        '/complaint',
        '/complaint-new'
    ];

    const isSelectDisabled = disabledUrls.some(url =>
        location.pathname === url || location.pathname.startsWith(url + '/')
    );

    const handleCompanyChange = (event) => {
        const userCompanyId = event.target.value;
        const activeCompany = availableCompanies.find((company) => company.contactId === userCompanyId);

        if (!activeCompany || activeCompany.contactId === activeUserCompany.contactId) {
            return;
        }

        if (cartItems && cartItems.length > 0) {
            event.target.value = activeUserCompany.contactId;

            confirmAlert({
                title: t('company.change.confirm.title'),
                message: t('company.change.confirm.message'),
                buttons: [
                    {
                        label: t('button.no'),
                        onClick: () => {
                            // Do nothing, keep current company
                        },
                        className: 'button-secondary',
                    },
                    {
                        label: t('button.yes'),
                        onClick: () => {
                            clearCart();
                            globalDispatch({
                                type: 'SET_ACTIVE_USER_COMPANY',
                                payload: activeCompany,
                            });
                        },
                        className: 'button-primary',
                    },
                ],
            });
        } else {
            globalDispatch({
                type: 'SET_ACTIVE_USER_COMPANY',
                payload: activeCompany,
            });
        }
    };

    if (!availableCompanies || availableCompanies.length < 2) {
        return null;
    }

    const sortedCompanies = [...availableCompanies].sort((a, b) =>
        a.accountName.localeCompare(b.accountName)
    );

    return (
        <div className="company-select">
            <select
                id="company-selector"
                value={activeUserCompany.contactId || ''}
                onChange={handleCompanyChange}
                className="company-select-dropdown"
                disabled={isSelectDisabled}
            >
                {sortedCompanies.map((company) => (
                    <option key={company.contactId} value={company.contactId}>
                        {company.accountName}
                    </option>
                ))}
            </select>
        </div>
    );
}
